import { render, staticRenderFns } from "./ReceiptHeader.vue?vue&type=template&id=eb1466bc&scoped=true"
import script from "./ReceiptHeader.vue?vue&type=script&lang=js"
export * from "./ReceiptHeader.vue?vue&type=script&lang=js"
import style0 from "./ReceiptHeader.vue?vue&type=style&index=0&id=eb1466bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1466bc",
  null
  
)

export default component.exports